import { parse } from 'cookie';
import { _days } from '@toptoon/utils/_day';
import { TypeCheck } from '@toptoon/utils';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advanced from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);

/**
 * getServerSideProps의 context에서 cookie를 받아 반환
 * @param context
 * @returns
 */
export const parseSSRCookies = (context: any) => {
  // For API Routes we don't need to parse the cookies.
  if (context.req.cookies) return context.req.cookies;

  // For pages we do need to parse the cookies.
  const cookie = context.req.headers?.cookie;
  return parse(cookie || '');
};

export const getSSRCookie = (context: any, key: string) => {
  const cookies = parseSSRCookies(context);
  if (cookies === '') return null;
  return cookies[key];
};

/**
 * refer 주소가 우리 주소인지 반환
 * @param context
 * @returns
 */
export const isRefererCheck = (context: any) => {
  const { referer } = context.req.headers;
  if (referer) {
    return referer.startsWith(`${process.env.NEXT_PUBLIC_PUBLIC_URL}`) > 0;
  } else {
    return false;
  }
};

export const remainingDate = (t: string) => {
  if (t === null || t === '') return '';

  const now = _days.day().utc();
  const date = _days.day(t).utc();

  const day = date.diff(now, 'days');
  if (day >= 1) {
    return `${day} D`;
  }

  const hour = _days.day.duration(date.diff(now)).hours();
  if (hour >= 1) {
    return `${hour} H`;
  }

  const min = _days.day.duration(date.diff(now)).minutes();
  if (min >= 1) {
    return `${min} M`;
  }
  return '';
};

export const numberToBoolean = (data: any, key: string) => {
  if (!TypeCheck.itemsByPath(data, key)) return false;

  return data[key] === 1 ? true : false;
};

const noImgPath = '/images/common/img_loading.png';

export const thumbnailToPath = (data: any, key: string) => {
  if (!TypeCheck.itemsByPath(data, key)) return noImgPath;

  return data[key].length > 0 ? data[key][0].path : noImgPath;
};

export const addComma = (num: number) => {
  try {
    const regexp = /\B(?=(\d{3})+(?!\d))/g;
    return num.toString().replace(regexp, ',');
  } catch (error) {
    return num;
  }
};

export const getUtcTimestamp = (data: any): number => {
  if (!TypeCheck.isValidString(data)) return 0;

  return dayjs(`${data}`).utc().valueOf();
};
